import React, { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { api } from "../lib/api";
import { TrustpilotReviewCollector } from "./TrustpilotReviewCollector";

export const Reviews = () => {
  const [ratings, setRatings] = useState(null);

  useEffect(() => {
    api
      .get("/reviews")
      .then((r) => setRatings(r.data.ratings || null))
      .catch(() => {});
  }, []);

  return (
    <section id="reviews" className="py-16 md:py-24 bg-stylist-bg2">
      <div className="max-w-5xl mx-auto px-4 sm:px-8 lg:px-16 text-center">
        <span className="eyebrow">Reviews</span>
        <h2 className="mt-3 font-serif text-3xl sm:text-4xl lg:text-5xl text-stylist-ink">
          Rated by clients & stylists
        </h2>
        <p className="mt-5 text-stylist-ink2 max-w-xl mx-auto">
          Don't just take our word for it. Read what our community says on the App Store, and share
          your own experience with us on Trustpilot.
        </p>

        {ratings && (
          <div className="mt-10 flex flex-wrap justify-center gap-4">
            <RatingBadge
              label="Apple App Store"
              score={ratings.appstore.score}
              count={ratings.appstore.count}
            />
          </div>
        )}

        <div className="mt-10 flex justify-center" data-testid="trustpilot-widget-wrap">
          <TrustpilotReviewCollector />
        </div>
      </div>
    </section>
  );
};

const RatingBadge = ({ label, score, count }) => (
  <div className="flex items-center gap-4 bg-white border border-stylist-border rounded-full pl-5 pr-6 py-3">
    <div className="text-left">
      <p className="text-xs font-mono uppercase tracking-widest text-stylist-muted">{label}</p>
      <div className="flex items-center gap-1 mt-1">
        {[...Array(5)].map((_, i) => (
          <Star key={i} className="w-3.5 h-3.5 fill-stylist-gold text-stylist-gold" />
        ))}
      </div>
    </div>
    <div className="border-l border-stylist-border pl-4 text-left">
      <span className="font-serif text-2xl text-stylist-ink">{score}</span>
      <span className="text-sm text-stylist-muted">/5</span>
      <p className="text-xs text-stylist-muted">{count} reviews</p>
    </div>
  </div>
);
